
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useIsMobile } from "@/hooks/use-mobile";

interface AddressFieldsProps {
  values: {
    street2: string;
    city: string;
    province: string;
    postalCode: string;
    country: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  prefix: string;
}

export const AddressFields = ({ values, onChange, prefix }: AddressFieldsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-3">
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-3`}>
        <div className="space-y-1">
          <Label htmlFor={`${prefix}-city`} className="text-xs">City *</Label>
          <Input
            id={`${prefix}-city`}
            name="city"
            value={values.city}
            onChange={onChange}
            className="h-8 w-full"
            required
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${prefix}-province`} className="text-xs">Province *</Label>
          <Input
            id={`${prefix}-province`}
            name="province"
            value={values.province}
            onChange={onChange}
            className="h-8 w-full"
            required
          />
        </div>
      </div>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-3`}>
        <div className="space-y-1">
          <Label htmlFor={`${prefix}-postal`} className="text-xs">Postal Code *</Label>
          <Input
            id={`${prefix}-postal`}
            name="postalCode"
            value={values.postalCode}
            onChange={onChange}
            className="h-8 w-full"
            required
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${prefix}-country`} className="text-xs">Country *</Label>
          <Input
            id={`${prefix}-country`}
            name="country"
            value={values.country}
            onChange={onChange}
            className="h-8 w-full"
            required
          />
        </div>
      </div>
    </div>
  );
};
